import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CusButton from '../../../../components/material-ui/CusButton';
import CusSwitch from '../../../../components/material-ui/CusSwitch';
import CusInput from '../../../../components/material-ui/CusInput';
import { t } from 'i18next';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';
import { API_CASINO } from '../../../../api/casino';
import useToast from '../../../../hooks/useToast';
import { useTranslation } from 'react-i18next';

export default function CaptchaKeys({ info, casinoId }) {
  const { t } = useTranslation();
  const { successToast, errorToast } = useToast();

  const [reCaptchaEnabled, setReCaptchaEnabled] = useState(!!info);
  const [captchaInfo, setCaptchaInfo] = useState(info || {});
  const { isMobile } = useBootstrapSize();

  const infoString = JSON.stringify(info);

  useEffect(() => {
    setCaptchaInfo(info || {});
    setReCaptchaEnabled(info?.enabled);
  }, [infoString]);

  const typographyWidth = isMobile ? undefined : 180;

  const onBtnClick = () => {
    if (reCaptchaEnabled) {
      if (!captchaInfo.publicKey) {
        errorToast(t('Enter the public key'));
        return;
      }

      if (!captchaInfo.secretKey) {
        errorToast(t('Enter the secret key'));
        return;
      }
    }

    const captcha = {
      enabled: reCaptchaEnabled,
      publicKey: captchaInfo.publicKey,
      secretKey: captchaInfo.secretKey
    };

    API_CASINO.captcha
      .set({
        casinoId,
        data: { captcha: captcha }
      })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  const onChangeEnabled = () => {
    setReCaptchaEnabled((prev) => !prev);
  };

  return (
    <Stack gap={2}>
      <CusSwitch
        label={'Use Google reCAPTCHA (version 2)'}
        fontWeight={600}
        fontSize={16}
        checked={reCaptchaEnabled}
        onChange={onChangeEnabled}
        reverse={isMobile}
        sx={{ mr: 'auto' }}
      />
      <Stack gap={1}>
        <CusInput
          label={t('Site key (Public key)') + ' :'}
          value={captchaInfo.publicKey}
          onChange={(e) => setCaptchaInfo((prev) => ({ ...prev, publicKey: e.target.value }))}
          isRow={!isMobile}
          typographyWidth={typographyWidth}
        />
        <CusInput
          label={t('Secret key') + ' :'}
          value={captchaInfo.secretKey}
          onChange={(e) => setCaptchaInfo((prev) => ({ ...prev, secretKey: e.target.value }))}
          isRow={!isMobile}
          typographyWidth={typographyWidth}
        />
      </Stack>
      <CusButton text="Save" onClick={onBtnClick} boxProps={{ ml: 'auto' }} sx={{ px: 5 }} />
    </Stack>
  );
}
